const circleArea = (radius: number): number => {
    return Math.PI * radius ** 2;
};

export default circleArea;
